
import apiClient from './client';

export const MedicalActivityAxiosInstance = apiClient;